import React, { useState, useEffect } from 'react';

export default function EscalationTimer({ matchStartTime }) {
  const [elapsedStr, setElapsedStr] = useState('00:00');
  const [multiplier, setMultiplier] = useState(1);

  useEffect(() => {
    if (!matchStartTime) return;

    const interval = setInterval(() => {
      const elapsedMs = Date.now() - matchStartTime;
      const totalSeconds = Math.floor(elapsedMs / 1000);
      
      const mins = Math.floor(totalSeconds / 60);
      const secs = totalSeconds % 60;
      setElapsedStr(`${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`);

      if (mins >= 60) {
        setMultiplier(4);
      } else if (mins >= 30) {
        setMultiplier(2);
      } else {
        setMultiplier(1);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [matchStartTime]);

  if (!matchStartTime) return null;

  let bg = 'rgba(0,0,0,0.3)';
  let color = 'var(--text-primary)';
  let badge = null;

  if (multiplier === 4) {
    bg = 'rgba(255, 0, 0, 0.2)';
    color = '#ff4d4d';
    badge = <span style={{ marginLeft: '8px', background: '#ff4d4d', color: '#000', padding: '2px 6px', borderRadius: '4px', fontSize: '0.8rem', fontWeight: 'bold', animation: 'pulse 1s infinite' }}>MAX 4x STAKES</span>;
  } else if (multiplier === 2) {
    bg = 'rgba(212, 175, 55, 0.2)';
    color = '#facc15';
    badge = <span style={{ marginLeft: '8px', background: '#facc15', color: '#000', padding: '2px 6px', borderRadius: '4px', fontSize: '0.8rem', fontWeight: 'bold' }}>2x STAKES</span>;
  } else {
    color = '#d4af37'; // Match theme when not multiplied
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: bg, padding: '8px', borderRadius: '8px', marginBottom: '8px', transition: 'all 0.5s ease', border: `1px solid ${multiplier > 1 ? color : 'rgba(212, 175, 55, 0.2)'}` }}>
      <div style={{ fontSize: '0.65rem', fontWeight: '800', color: multiplier > 1 ? color : '#94a3b8', letterSpacing: '1px', marginBottom: '4px' }}>ESCALATION PROTOCOL</div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <span style={{ fontSize: '1.4rem', fontWeight: 'bold', color: color, fontFamily: 'monospace' }}>
          {elapsedStr}
        </span>
        {badge}
      </div>
    </div>
  );
}
